import React, { Suspense } from 'react';
import { selectIsLogged } from '@bonanza-social/auth/state';
import { useSelector } from '@bonanza-social/toolkit/state';
import { ErrorBoundaryProvider } from '@bonanza-social/navigation';

const DynamicRoute = ({
  AuthenticatedComponent,
  AnonymousComponent,
}: {
  AuthenticatedComponent: React.ComponentType;
  AnonymousComponent: React.ComponentType;
}) => {
  const isLogged = useSelector(selectIsLogged);
  const Component = isLogged ? AuthenticatedComponent : AnonymousComponent;

  return (
    <ErrorBoundaryProvider>
      <Suspense
        fallback={
          <div style={{ height: 'var(--inner-height)' }}>Loading...</div>
        }
      >
        <Component />
      </Suspense>
    </ErrorBoundaryProvider>
  );
};

export default DynamicRoute;
